module.exports = __webpack_public_path__ + "static/media/sh.b696c28d.svg";